import { ArrowLeft, KeyRound } from 'lucide-react'
import { Link } from 'react-router-dom'

export function ForgotPasswordPage() {
  return <main className="login-shell"><section className="login-panel" aria-labelledby="forgot-title">
    <div className="brand-mark"><KeyRound /></div><p className="eyebrow">Recuperação de acesso</p><h1 id="forgot-title">Esqueci minha senha</h1>
    <p className="supporting-copy">Solicite a redefinição de senha ao administrador do sistema.</p>
    <Link className="login-back" to="/login"><ArrowLeft />Voltar ao login</Link>
  </section></main>
}
